var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('mt-header',{staticClass:"header",attrs:{"title":_vm.title}},[_c('header-item',{attrs:{"slot":"left","isBack":true},on:{"onclick":_vm.goBack},slot:"left"})],1),_vm._v(" "),_c('iframe',{staticClass:"content-wrapper",style:(_vm.getFrameStyle),attrs:{"id":"iframe","src":_vm.getUrl}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6865a9b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/auth/WebPage.vue
// module id = null
// module chunks = 